"use client";

import { useState, useEffect } from "react";
import { useSearchParams } from "next/navigation";
import { SearchInterface } from "@/customcomponents/creators/browse/CreatorSearchInterface";
import { useRouter } from "next/navigation";
import ControlDemoComponents from "@/components/demo/creators/CreatorsControlDemoComponents";

// Cookie helper functions
const getCookie = (name: string): string | null => {
  if (typeof document === 'undefined') return null;
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(';').shift() || null;
  return null;
};

const setCookie = (name: string, value: string, days: number = 365) => {
  if (typeof document === 'undefined') return;
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
};

export default function DemoCreatorPage() {
  const searchParams = useSearchParams();
  const intendedRoute = searchParams?.get("intended");
  const router = useRouter();
  const [showTour, setShowTour] = useState(false);

  // Check cookies on mount and show tour if not seen
  useEffect(() => {
    const hasSeenCreatorsTour = getCookie('creators_tour_completed');
    
    if (!hasSeenCreatorsTour) {
      setShowTour(true);
    }
  }, []);

  const handleTourComplete = () => {
    setShowTour(false);
    setCookie('creators_tour_completed', 'true');
  };

  return (
    <>
      <main className="min-h-screen bg-background relative">
        <div className="container mx-auto py-8">
          <div className="mb-8 space-y-2" data-guide-step="title">
            <h1 className="text-3xl font-bold tracking-tight">
              Browse Creators
            </h1>
            <p className="text-muted-foreground">
              Discover talented creators. Filter by categories, location, social media presence, and more.
            </p>
          </div>

          <div data-guide-step="search-interface">
            <SearchInterface
              campaign={undefined}
              campaignId={undefined}
              canInvite={false}
            />
          </div>
        </div>
      </main>
      
      {/* Guide overlay */}
      {showTour && (
        <ControlDemoComponents 
          intendedRoute={intendedRoute} 
          onNavigate={(to) => router.push(to)}
          onComplete={handleTourComplete}
        />
      )}
    </>
  );
}
